// serviceName and serviceVersion have to be added by webpack in country web-loan-application project
/* eslint-disable no-undef */
/* eslint-disable object-shorthand */

import Vue from 'vue';
import { ApmVuePlugin } from '@elastic/apm-rum-vue';

function startApm (router, apmEnabled, environment) {
  if (router && apmEnabled && environment && apmCanBeStarted(environment)) {
    Vue.use(ApmVuePlugin, {
      router,
      config: {
        active: apmEnabled,
        environment: environment,
        serverUrl: 'https://apm.bigbank.eu',
        distributedTracingOrigins: [window.location.origin],
        serviceVersion: serviceVersion,
        serviceName: serviceName,
      },
    });
  } else {
    console.log('APM did not start, either router, apmEnabled or environment is undefined or environment is set to local');
  }
}

function apmCanBeStarted(environment) {
  return serviceName !== undefined && serviceVersion !== undefined && environment !== 'local';
}

export default { startApm };
